import React, { useContext, useEffect } from 'react';
import { ICreateVideoContext, CreateVideoContext } from '../../../../../createVideoState/createVideoContext';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import StudioField from './components/StudioField/StudioField';
import NameVideoInput from './components/NameVideoInput';
import CategorySelect from './components/CategorySelect';
import VideoFileBlock from './components/VideoFileBlock';
import TranslationsMultipleSelect from './components/TranslationsMultipleSelect';
import BtnBlock from './components/BtnBlock';
import Text from 'components/Text/Text';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const { setMainFormValidationFail, additionalValidationErrors } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const {
		changeTypeOfModalWindow,
		setFetchedStudios,
		setIDStudio,
		refetchStudios,
		changeNameOfVideo,
		setIDCategory,
		setFetchedCategories,
		changeFileData,
		setIDsLanguages,
		setFetchedLanguages,
		setDataForSubmit,
		fileId,
		IDSelectedStudio,
		needRefetchStudios,
		nameOfVideo,
		IDSelectedCategory,
		fileData,
		IDsSelectedLanguages,
		translations,
	} = useContext<ICreateVideoContext>(CreateVideoContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ IDSelectedStudio });
		form.setFieldsValue({ nameOfVideo });
		form.setFieldsValue({ IDSelectedCategory });
		form.setFieldsValue({ IDsSelectedLanguages });
	}, [IDSelectedStudio, nameOfVideo, IDSelectedCategory, IDsSelectedLanguages]);

	const submit = async () => {
		const someTranslationIsEmpty = translations.some((translation) => translation.name === '');
		if (someTranslationIsEmpty) {
			changeTypeOfModalWindow('someTranslationIsEmpty');
			return;
		}

		setMainFormValidationFail(false);
		setDataForSubmit({
			name: nameOfVideo,
			videoCategoryId: IDSelectedCategory || '',
			videoStudioId: IDSelectedStudio || '',
			iconFileId: fileId || '',
			videoFileId: fileData.fileId,
			translations: translations,
		});
		additionalValidationErrors.length
			? setMainFormValidationFail(true)
			: changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleFormValidationFail = () => {
		setMainFormValidationFail(true);
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form
				form={form}
				name="basic"
				onFinish={submit}
				onKeyPress={preventDefaultForEnterKey}
				onFinishFailed={handleFormValidationFail}
				layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<StudioField
						setFetchedStudios={setFetchedStudios}
						setIDStudio={setIDStudio}
						refetchStudios={refetchStudios}
						changeTypeOfModalWindow={changeTypeOfModalWindow}
						needRefetchStudios={needRefetchStudios}
					/>
					<NameVideoInput changeNameOfVideo={changeNameOfVideo} />
					<CategorySelect setIDCategory={setIDCategory} setFetchedCategories={setFetchedCategories} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="setupNewVideoFileHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<Text
						className={style.requiredLabel}
						translationNameSpace="form"
						translationKey="requiredLabel"
						theme="secondary"
						size="s"
						weight="bold"
						display="inline"
					/>
					<VideoFileBlock
						changeFileData={changeFileData}
						changeTypeOfModalWindow={changeTypeOfModalWindow}
						fileData={fileData}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="translationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<TranslationsMultipleSelect
						setIDsLanguages={setIDsLanguages}
						setFetchedLanguages={setFetchedLanguages}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
